import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles'; 

const useStyles = makeStyles(theme => ({
  text: {
    textAlign: 'center',
  }
}));

function ErrorComponent({children, error}) {
  const classes = useStyles();

  if(error){
    return (
      <Grid container item justify="center" alignContent="center">
        <Typography className={classes.text}>
          There was an error loading the app. Please try again or contact Rob.
        </Typography>
      </Grid>
    )
  }

  return children;
}

export default ErrorComponent;
